module.exports = __webpack_public_path__ + "static/logo-0956bd00866f28de61b9c29dd3d853bb.png";